module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-sync-8180085837039e70daf98bbd3556ecf5.svg";